import { Suspense, lazy, useCallback, useState } from "react";
import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router";
import { appConfig } from "@shared/utils/appConfig";
import { getApiRootUrl } from "@shared/utils/api-root-url";
import { ActionsContainer } from "../styles";
import { DisclaimerCard } from "./styles";
import { SubscriptionSubmitButton } from "@features/Subscription/components/styles";
import { SubscriptionBackButton } from "@features/Subscription/components/SubscriptionBackButton";
const StartSsoMlsSubscriptionMock = lazy(() =>
  import("./StartSsoMlsSubscription.mock").then((module) => ({
    default: module.StartSsoMlsSubscriptionMock,
  })),
);

const isDev = appConfig.APP_ENV === "development";

interface Props {
  planId: string;
  planName: string;
}

export const StartSsoMlsSubscription = (props: Props) => {
  const { planId, planName } = props;
  const navigate = useNavigate();
  const [isRedirecting, setIsRedirecting] = useState(false);

  const SSO_URL = `${getApiRootUrl()}/auth/login/sso/${planId}/start?flow=subscription`;

  const handleClickSignIn = useCallback(() => {
    setIsRedirecting(true);
    localStorage.setItem("@sidekick:registration-start-pending", "true");
  }, []);

  if (isDev) {
    return (
      <Suspense>
        <StartSsoMlsSubscriptionMock ssoUrl={SSO_URL} planName={planName} />
      </Suspense>
    );
  }

  return (
    <Box>
      <SubscriptionBackButton
        onClick={() => navigate("/subscribe/mls")}
        disabled={isRedirecting}
      />
      <Box mb={2}>
        <DisclaimerCard mb={3}>
          <Typography>
            In the next step you need to sign in with your {planName} account.
            After that, we will guide you to complete the registration.
          </Typography>
        </DisclaimerCard>
      </Box>
      <ActionsContainer>
        <SubscriptionSubmitButton
          href={SSO_URL}
          onClick={handleClickSignIn}
          isLoading={isRedirecting}
          type="button"
        >
          Sign-in
        </SubscriptionSubmitButton>
      </ActionsContainer>
    </Box>
  );
};
